<template>
  <div class="PlatformUserDetailsView">
    <UserProfileHeader :user="user"
                       :is-loading="isLoading"
                       @refreshUserData="$store.dispatch('user/getDetails', userUuid)"
    />
    <ShPageLayout padding="80px">
      <el-row :gutter="20">
        <el-col :xs="24"
                :sm="24"
                :ls="24"
                :xl="24"
        >
          <ShCard title="Dane podstawowe">
            <UserData slot="content"
                      :user="user"
                      :user-uuid="userUuid"
                      :is-loading="isLoading"
                      @refreshUserData="$store.dispatch('user/getDetails', userUuid)"
                      @showEditionModal="showEditionModal"
            />
          </ShCard>
        </el-col>
      </el-row>
      <div
        v-if="$store.getters['authorization/acl'].hasAccessForRoles(['owner', 'manager'])"
        class="PlatformUserDetailsView__action-buttons"
      >
        <el-button size="small"
                   @click="goToUsersList()"
        >
          <i class="fa fa-reply" />
          Wróć do listy plików
        </el-button>
      </div>
    </ShPageLayout>
    <ShSideBarModal :side-bar-modal-visibility.sync="sideBarModalVisibility"
                    :is-loading="isLoading"
                    :title="'Edycja danych użytkownika'"
                    :description="'Uzupełnij poniższy formularz aby zmienić dane użytkownika.'"
    >
      <UserEditionForm slot="content"
                       :user-details="user"
                       @closeModal="closeModal"
      />
    </ShSideBarModal>
  </div>
</template>

<script>
import { customValidations } from '@/mixins';
import UserProfileHeader from '@/components/Users/UserProfileHeader';
import UserData from '@/components/Users/UserData';
import UserEditionForm from '@/components/Users/UserEditionForm';

export default {
  name: 'PlatformUserDetails',

  components: {
    UserProfileHeader,
    UserData,
    UserEditionForm,
  },

  mixins: [customValidations],


  props: {
    userUuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      sideBarModalVisibility: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/details'].record;
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'user/getDetails',
        'user/updateUser',
      ]);
    },
  },

  created() {
    const userUuid = this.$route.params.user.user_uuid;
    if (this.mUuidValidation(userUuid)) {
      this.$store.dispatch('user/getDetails', userUuid);
    } else {
      this.$router.push({ name: 'PlatformDashboard' });
    }
  },

  methods: {
    goToUsersList() {
      this.$router.push({ name: 'PlatformDashboard' });
    },
    closeModal() {
      this.sideBarModalVisibility = false;
    },
    showEditionModal() {
      this.sideBarModalVisibility = !this.sideBarModalVisibility;
    },
  },
};
</script>

<style lang="sass" scoped>
.PlatformUserDetailsView
  &__action-buttons
    margin-top: 15px
    text-align: right
</style>
